import { render, staticRenderFns } from "./youtube-media-player-cmp-extended.vue?vue&type=template&id=a0e86f44&scoped=true"
import script from "./youtube-media-player-cmp-extended.vue?vue&type=script&lang=js"
export * from "./youtube-media-player-cmp-extended.vue?vue&type=script&lang=js"
import style0 from "./youtube-media-player-cmp-extended.vue?vue&type=style&index=0&id=a0e86f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e86f44",
  null
  
)

export default component.exports